import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { AbstractControl, UntypedFormGroup } from '@angular/forms';

import { v4 as uuid } from 'uuid';

import { SvgLibraryIcon } from '@finnairoyj/fcom-ui-styles';

import { FinnairTheme } from '@fcom/common/interfaces/theme.interface';
import { FinnairThemeService } from '@fcom/common/services/theme/finnair-theme.service';

import { RadioButtonTheme } from '../enums';
import { RadioItemGroupOption } from '../interfaces';
@Component({
  selector: 'fcom-radio-item-group',
  templateUrl: './radio-item-group.component.html',
  styleUrls: ['./radio-item-group.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RadioItemGroupComponent {
  readonly RadioButtonTheme = RadioButtonTheme;
  readonly SvgLibraryIcon = SvgLibraryIcon;

  private readonly themeService = inject(FinnairThemeService);

  protected readonly isNewBrand = this.themeService.siteTheme() !== FinnairTheme.LEGACY;

  theme = input(RadioButtonTheme.ROUND);

  parentForm = input.required<UntypedFormGroup>();

  controlName = input.required<string>();

  options = input.required<RadioItemGroupOption[]>();

  name = input<string | undefined>();

  isRequired = input(false);

  /**
   * This input is needed if you want to use title, helper or error text
   */
  translationPrefix = input<string | undefined>();

  /**
   * translationPrefix is needed if you want to use this text
   */
  helperText = input(false);

  /**
   * translationPrefix is needed if you want to use this text
   */
  titleText = input(true);

  /**
   * translationPrefix is needed if you want to use this text
   */
  errorText = input(true);

  /**
   * the field input hidden in analytics such as Hotjar
   */
  isSensitive = input(false);

  /**
   * The round theme is by default vertical, but it can be forced to horizontal
   */
  isHorizontal = input(false);

  /**
   * Set to `false` if you want to hide the required error message.
   * This is useful if you want to show a custom error message instead.
   */
  showRequiredError = input(true);

  /**
   * Optional prefix for test IDs on individual radio options
   */
  testIdPrefix = input<string | undefined>();

  readonly control = computed<AbstractControl>(() => this.parentForm().get(this.controlName()));
  readonly id = uuid();

  protected readonly twoItemMode = computed(() => this.options().length === 2);
}
